<template lang="pug">
.monthly-stat
  .blue-gradient.px-4.py-4
    .text-large
      | เป้าหมายประจำเดือน
      | {{ displayMonth }}
    //- .text-small {{ fromISO }}
    //- .text-small {{ toISO }}
    .d-flex.py-2.justify-content-center(v-if='goalDashboardStatic && goalDashboardStatic.month')
      ProfilePerformanceStatItem(
        title='เป้าหมาย'
        :value='goalDashboardStatic.month.goal'
        size='36'
        :iconSrc='require(`@/assets/icons/target.svg`)'
      )
      ProfilePerformanceStatItem.ml-1(
        title='ยอดขายที่ทำได้'
        size='30' color='#E02020'
        :value='goalDashboardStatic.month.total_sale'
      )

    .px-4.mx-3
      .progress.mt-3
        .progress-bar(
          :style='`width: ${progressPercentCalc}%`'
        )
      .d-flex.justify-content-between.mt-2
        .text-19.text-turquoise.font-weight-500
          | {{ (goalDashboardStatic.month.total_sale) | currency }}
        .text-19.text-blue.font-weight-500
          | {{ (goalDashboardStatic.month.goal) | currency }}

    //- .d-flex.px-4.mx-3.mt-4.mb-2
    //-   button.btn.btn-secondary.ml-auto(@click='setMonthlyGoal')
    //-     | ตั้งค่าเป้าประจำเดือน

  hr.m-0

  .px-4.py-4
    .text-large สถิติการขาย
    .d-flex.py-2.justify-content-center
      ProfilePerformanceStatItem(
        title='ค่าคอมมิชชั่นสะสม'
        :value='goalDashboard.dynamic.total_commission'
        color='#E02020'
        :iconSrc='require(`@/assets/icons/investment.svg`)'
      )
      ProfilePerformanceStatItem.ml-1(
        title='ยอดขายสะสม'
        :value='goalDashboard.dynamic.total_sale'
        :iconSrc='require(`@/assets/icons/profits.svg`)'
      )
    .d-flex.py-2.px-3.justify-content-between
      NumberWithDescription(
        :number='goalDashboard.dynamic.orders.total'
        description='รายการขาย'
      )
      NumberWithDescription(
        :number='goalDashboard.dynamic.orders.back_order'
        description='รายการ Back Order'
      )
      NumberWithDescription(
        :number='goalDashboard.dynamic.orders.cancelled'
        description='รายการยกเลิก'
      )
</template>

<script>
import ProfilePerformanceStatItem from '@/components/profile-performance/ProfilePerformanceStatItem.vue';

export default {
  props: {
    seller: {},
    month: {},
    year: {},
  },
  watch: {
    seller() { this.loadData(); },
    month() { this.loadData(); },
    year() { this.loadData(); },
  },
  computed: {
    progressPercentCalc() {
      if (this.goalDashboardStatic && this.goalDashboardStatic.month) {
        const {
          total_sale: totalSale,
          goal,
        } = this.goalDashboardStatic;
        return totalSale / goal * 100;
      }
      return 0;
    },

    fromISO() {
      let month = `${this.month + 1}`;
      if (month.length < 2) {
        month = `0${month}`;
      }
      return `${this.year}-${month}-01`;
    },

    toISO() {
      return this.$moment(this.fromISO).endOf('month').format('YYYY-MM-DD');
    },

    displayMonth() {
      return this.$moment(this.fromISO).format('MMMM YYYY');
    },
  },
  data: () => ({
    goalDashboard: {},
    goalDashboardStatic: {},
  }),
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.isLoading = true;
      // const resGoalDashboard = await this.$api.user.goalDashboard({ ...this.filterDate });
      let resGoalDashboard;
      if (this.fromISO && this.toISO) {
        resGoalDashboard = await this.$api.admin.sellerRecords.goalDashboard(
          this.seller.id,
          {
            from: this.fromISO,
            to: this.toISO,
          },
        );
      } else {
        resGoalDashboard = await this.$api.admin.sellerRecords.goalDashboard(this.seller.id);
      }

      if (resGoalDashboard.status === 200) {
        if (Object.keys(this.goalDashboardStatic).length === 0) {
          this.goalDashboardStatic = resGoalDashboard.data; // initial only
        }
        this.goalDashboard = resGoalDashboard.data;

        this.isLoading = false;
      }
    },
  },
  components: {
    ProfilePerformanceStatItem,
  },
};
</script>

<style lang="scss">
// .monthly-stat {}
</style>
